export default "__VITE_ASSET__BZB_XQVR__"